<div class="flow-config-modal">
  <h2 mat-dialog-title>
    <mat-icon>settings</mat-icon>
    Configurar Execução de Fluxo
  </h2>

  <mat-dialog-content>
    <form [formGroup]="form" class="flow-config-form">
      
      <!-- Campo de busca para IDCONF -->
      <div class="form-field">
        <label class="required">Configuração de Fluxo (IDCONF)</label>
        
        <div class="search-box">
          <div class="search-input-wrapper">
            <mat-icon class="search-prefix">search</mat-icon>
            <input 
              type="text"
              class="search-input"
              [(ngModel)]="searchText"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onSearchChange($event)"
              placeholder="Pesquise por nome ou ID..."
              [disabled]="loading"
              autocomplete="off">
            <button 
              *ngIf="selectedConfiguration" 
              mat-icon-button 
              class="search-clear"
              (click)="clearSelection()"
              type="button">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- Lista de resultados -->
          <div class="results-list" *ngIf="filteredConfigurations.length > 0 && !selectedConfiguration && searchText">
            <div 
              *ngFor="let config of filteredConfigurations | slice:0:10"
              class="result-item"
              (click)="selectConfiguration(config)">
              <div class="result-main">
                <span class="result-id">#{{ config.IDCONF }}</span>
                <span class="result-name">{{ config.NAME }}</span>
              </div>
              <div class="result-meta">
                <span class="result-mktp">{{ config.CODEMKTP_NAME }}</span>
                <span class="result-company">{{ config.CODECOMPANY_NAME }}</span>
                <span class="result-engine" [class.is-new]="config.NEWMODE === 'S'">
                  {{ config.NEWMODE === 'S' ? 'Fluxo novo' : 'Fluxo antigo' }}
                </span>
              </div>
            </div>
            <div *ngIf="filteredConfigurations.length === 0" class="no-results">
              Nenhuma configuração encontrada
            </div>
          </div>

          <!-- Configuração selecionada -->
          <div class="selected-config" *ngIf="selectedConfiguration">
            <mat-icon class="selected-icon">check_circle</mat-icon>
            <div class="selected-info">
              <div class="selected-main">
                <strong>#{{ selectedConfiguration.IDCONF }}</strong> - {{ selectedConfiguration.NAME }}
              </div>
              <div class="selected-meta">
                {{ selectedConfiguration.CODEMKTP_NAME }} | {{ selectedConfiguration.CODECOMPANY_NAME }}
                &nbsp;&middot;&nbsp;
                <strong>{{ selectedConfiguration.NEWMODE === 'S' ? 'Fluxo novo (assíncrono)' : 'Fluxo antigo' }}</strong>
              </div>
            </div>
          </div>

          <!-- Loading -->
          <div class="loading-indicator" *ngIf="loading">
            <mat-icon class="spin">refresh</mat-icon>
            Carregando configurações...
          </div>
        </div>
        
        <small class="help-text">Selecione qual configuração MKTPCFG será executada ao clicar no botão</small>
      </div>

      <!-- Checkbox: Permitir seleção de empresa -->
      <div class="form-field">
        <mat-checkbox formControlName="showCodeCompany">
          Permitir que o usuário selecione a empresa ao executar
        </mat-checkbox>
        <small class="help-text">
          Se ativado, o usuário poderá escolher a empresa no momento da execução
        </small>
      </div>

      <!-- Select: Empresa Fixa -->
      <div class="form-field" *ngIf="!form.get('showCodeCompany')?.value">
        <label>Empresa Fixa</label>
        <select 
          class="custom-select"
          formControlName="codeCompany">
          <option [value]="null">Empresa do usuário logado</option>
          <option 
            *ngFor="let company of userCompanies" 
            [value]="company.codecompany">
            {{ company.codecompany }} - {{ company.companyname }}
          </option>
        </select>
        <small class="help-text">
          Deixe vazio para usar a empresa do usuário logado
        </small>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!isValid">
      <mat-icon>check</mat-icon>
      Confirmar
    </button>
  </mat-dialog-actions>
</div>
